import '../../../styles/Map.scss';
import React, { useState } from "react";
import fireIcon from '../../../assets/icons/fire-gif.gif';
import calendar from '../../../assets/icons/calendar-icon.png';
import location from '../../../assets/icons/location-icon.png';
import left from '../../../assets/icons/left.png';

export default function SensorDataPopup({ setPanel, user, map, data}) {
    const [loading, setLoading] = useState(false);

    return (
        <>
        { data &&
            <div className='map-controls-settings-window-activeFire'>
                <div className='map-controls-settings-window-activeFire-info'>
                    <div className='map-controls-settings-window-activeFire-info-return' onClick={() => setPanel({name: 'Active Fires', content: null})}>
                        <img src={left} className='map-controls-settings-window-activeFire-info-return-icon'/>
                        Back to results
                    </div>
                    <div className='map-controls-settings-window-activeFire-title'>
                        <img src={fireIcon} className='map-controls-settings-window-activeFire-title-icon'/>
                        <div className='map-controls-settings-window-activeFire-title-text'></div>
                    </div>
                    <div className='map-controls-settings-window-activeFire-row'>
                        <img src={calendar} className='map-controls-settings-window-activeFire-row-icon'/>
                        <div className='map-controls-settings-window-activeFire-row-value'></div>
                    </div>
                    <div className='map-controls-settings-window-activeFire-row'>
                        <img src={location} className='map-controls-settings-window-activeFire-row-icon'/>
                        <div className='map-controls-settings-window-activeFire-row-value'></div>
                    </div>
                    <div className='map-controls-settings-window-activeFire-fields'>
                        <div className='map-controls-settings-window-activeFire-fields-name'>Cause</div>
                        <div className='map-controls-settings-window-activeFire-fields-value'></div>
                    </div>
                    <div className='map-controls-settings-window-activeFire-fields'>
                        <div className='map-controls-settings-window-activeFire-fields-name'>Confidence</div>
                        <div className='map-controls-settings-window-activeFire-fields-value'></div>
                    </div>
                    {/* <WeatherConditions data={fire.weather_data}/> */}
                    <div className='map-controls-settings-window-activeFire-share'>Share</div>
                </div>
            </div>
        }
        </>
    );
}